import React from "react"
import { Modal, ModalFooter } from "react-bootstrap"

export const EditAlertModal = ({course, show, setShow}) => {

  return (
    <Modal show={show} onHide={() => setShow(false)} className="center-modal">
      <div className="courses-modal-title-container">
        <div className="courses-modal-title">
          {window.I18n.t('courses.master_roster_courses.edit_course')}
        </div>
      </div>
      <Modal.Body className='add-margin-bottom-10 add-margin-top-10 courses-small-modal-body-container'>
        {
          window.I18n.t('courses.master_roster_courses.edit_course_info')
        }
      </Modal.Body>
      <ModalFooter>
        <div className="courses-modal-buttons-container">
          <button onClick={() => setShow(false)} className="cancel_action small grey button btsp_small_white_button">Cancel</button>
          <div>
            <a href={course.copyEditUrl} className="next_action small orange button btsp_small_orange_button add-margin-right-5">Create and Edit Copy</a>
            <a href={course.editUrl} className="next_action small orange button btsp_small_orange_button">Edit this Course</a>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}